// @ts-expect-error
import NProgress from "nprogress";

export function startNProgress() {
    NProgress.start();
}

export function endNProgess() {
    NProgress.done();
}

export function parseUTC(date: string, supabase: boolean) {
    // add z to indicate that it's utc. supabase doesn't include the z by default.
    return new Date(Date.parse(supabase ? `${date}Z` : date));
}

export function WIBDateTimeString(date: string, supabase: boolean, withTime: boolean = false) {
    const parsed = parseUTC(date, supabase);
    const tanggal = parsed.toLocaleDateString("id-ID");
    const waktu = parsed.toLocaleTimeString("sv-SE").split(":").slice(0, 2).join(":");
    if (withTime) {
        return `${tanggal}, ${waktu} WIB`;
    } else {
        return `${tanggal}`;
    }
}